import BootstrapModal from "bootstrap/js/dist/modal";

import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { UserAvatar } from "./user-avatar.js";
import { ShowLinkedUpdate } from "../lib/linked-update-modal.js";

UserAvatar.Register();

/**
 * Display a row of recent activity
 * Expects activity to be a nMealTrainActivity
 */
export class RecentActivityRow extends UnshadowedElement {
    static elementName() { return "recent-activity-row" }

    static properties = {
        activity: { type: Object },
    };

    HideActivityModal() {
        const modalElement = document.getElementById("modalTrainActivity");
        if (modalElement) {
            const modal = BootstrapModal.getOrCreateInstance(modalElement);
            modal.hide();
        }
    }

    ShowUpdate(activity) {
        this.HideActivityModal();
        ShowLinkedUpdate(activity.ObjectId);
    }

    render() {
        // Linkify description if needed
        let description = this.activity.Description;
        switch (this.activity.TypeId) {
            case 4:
                description = html`<a href="${window.CurrentTrain.OpenUrl}/donate/init">${this.activity.Description}</a>`;
                break;
            case 5:
                description = html`<a @click=${() => this.ShowUpdate(this.activity)}>${this.activity.Description}</a>`;
                break;
            case 6:
                description = html`<a data-bs-toggle="modal" data-bs-target="#modalGiftCardPicker">${this.activity.Description}</a>`;
                break;
        }
        return html`
            <div class="activity-row">
                <user-avatar avatar=${this.activity.User && this.activity.User.Avatar} initials=${this.activity.User && this.activity.User.Initials}></user-avatar>
                <div>
                    <p class="activity-row__title">${this.activity.FullName}</p>
                    <ul class="activity-row__data"><li>${description}</li><li>${this.activity.TimeAgo}</li></ul>
                </div>
            </div>
        `;
    }
}
